<template>
  <div>
    <md-progress-bar
      md-mode="indeterminate"
      v-show="!init || !loaded"
    ></md-progress-bar>
    <div id="skip" tabindex="-1" role="navigation">
      <a
        v-if="voterConfirmedIdentity"
        href="#identity-main"
        class="skip-main"
        role="navigation"
        :aria-label="$t('voter.jump-link')"
        >{{ $t("voter.jump-link") }}</a
      >

      <a
        v-if="electionsList"
        href="#list-main"
        class="skip-main"
        role="navigation"
        :aria-label="$t('voter.jump-link')"
        >{{ $t("voter.jump-link") }}</a
      >

      <a
        v-if="eventSelection"
        href="#event-main"
        class="skip-main"
        role="navigation"
        :aria-label="$t('voter.jump-link')"
        >{{ $t("voter.jump-link") }}</a
      >
    </div>

    <Header
      class="w-header"
      :showhelp="showhelp"
      :userDisabled="userDisabled"
      :voterLocale="
        $store.state.voterIdentification
          ? $store.state.voterIdentification.Voter.VoterInformation
              .PreferredLanguage
          : null
      "
      :eventLocale="
        $store.state.voterIdentification
          ? $store.state.voterIdentification.EnabledLanguage
          : null
      "
      @logoutRequest="
        !electionsList ? logout() : $refs['electionList'].tryLogout()
      "
    >
    </Header>

    <!-- <election-event class="scheda-w"></election-event> -->
    <event-selection
      v-if="eventSelection"
      @eventSelected="eventSelected"
      @electionsListRetrieved="loaded = true"
      @electionsListLoading="loaded = false"
      ref="eventSelection"
    ></event-selection>
    <div
      v-bind:class="
        voterConfirmedIdentity
          ? 'box-identity md-layout-item md-size-100 voter-box'
          : ''
      "
      role="main"
      v-if="!eventSelection"
      style=""
    >
      <identity
        v-if="voterConfirmedIdentity"
        @identityRetrieved="loaded = true"
        @identityNotRetrieved="loaded = false"
        @identityConfirmed="confirmIdentity()"
        ref="identity"
      >
      </identity>
      <election-list
        v-if="electionsList"
        ref="electionList"
        @electionsListRetrieved="loaded = true"
        @backToList="backToList()"
      >
      </election-list>
    </div>
    <div class="md-layout-item md-size-100">
      <md-button
        @click="backToList()"
        class="md-button md-raised backList"
        v-if="
          loaded &&
            electionsList &&
            $store.state.eventNumber > 1 &&
            $store.state.electionEvent.Rewritable
        "
        role="navigation"
        :aria-label="$t('election-list.back-to-events')"
      >
        <md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
        >
          {{ $t("election-list.back-to-events") }}
        </md-tooltip>
        {{ $t("election-list.back-to-events") }}
      </md-button>

      <v-footer v-if="!eventSelection"></v-footer>
    </div>
  </div>
</template>

<script>
import Identity from "./Identity";
import ElectionList from "./ElectionList";
import Header from "./Header";
import ElectionEvent from "./ElectionEvent";
import EventSelection from "./EventSelection";
import VFooter from "./VFooter";
import { isMobile } from "mobile-device-detect";
export default {
  async mounted() {
    this.isMobile = isMobile;
    //document.getElementById("skip").focus();
  },
  data: function() {
    return {
      voterConfirmedIdentity: false,
      electionsList: false,
      showhelp: false,
      userDisabled: true,
      isMobile: false,
      loaded: false,
      eventSelection: true
    };
  },
  props: ["init"],
  methods: {
    confirmIdentity() {
      // Alla conferma dell'identità il componente Identity viene disattivato e viene mostrato
      //l'elenco delle elezioni disponibili (ElectionList)
      this.voterConfirmedIdentity = false;
      this.electionsList = true;
      this.showhelp = true;
      if (this.$store.state.electionEvent.Lite) this.userDisabled = false;
      this.loaded = false;
    },
    eventSelected() {
      this.loaded = false;
      this.voterConfirmedIdentity = true;
      this.eventSelection = false;
    },
    backToList() {
      this.$store.commit("electionEventSetter", null);
      this.eventSelection = true;
      this.voterConfirmedIdentity = false;
      this.electionsList = false;
    },
    async logout() {
      if (this.$store.state.logoutUrl) {
        const url = this.$store.state.logoutUrl;
        this.$store.replaceState({});
        window.location.href = url;
      } else {
        this.$store.replaceState({});
        this.$keycloak.logoutFn();
      }
    }
  },
  components: {
    Identity,
    ElectionList,
    Header,
    // ElectionEvent,
    VFooter,
    EventSelection
  }
};
</script>

<style scoped>
.md-layout-item.md-size-100 {
  min-width: 90% !important;
  max-width: 95% !important;
  margin-left: none;
  flex: 1 1 100%;
  margin: 30px auto !important;
}
.md-card-content {
  padding: 16px;
  font-size: 18px;
  line-height: 22px !important;
}

.voter-box {
  background: #fff !important;
}

.box-identity {
  border-radius: var(--br);
  border: 2px solid var(--pcolor);
  padding: 12px 10px 20px 10px;
}

.custom {
  margin: 0px;
  padding: 5px;
}

.custom[data-v-bf1681ae] {
  margin: 0 !important;
  padding: 5px;
}

.resized {
  width: 30%;
}
.head {
  max-height: 100px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.md-button.md-raised:not([disabled]) {
  box-shadow: none !important;
  padding: 2px 20px 0 20px;
}

.scheda-w {
  box-shadow: none !important;
}

a.skip-main {
  left: -999px;
  position: absolute;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
  z-index: -999;
}
a.skip-main:focus,
a.skip-main:active {
  color: #000;
  background-color: #fff;
  left: 0;
  top: 0;
  width: auto;
  height: auto;
  overflow: auto;
  margin: 10px;
  padding: 5px;
  text-align: left;
  font-size: 1.2em;
  z-index: 999;
}
.backList {
  border: 1px solid var(--pcolor);
  background: #fff;
  margin-bottom: 20px;
  padding: 0 30px !important;
  font-weight: bold;
  height: 40px;
  border-radius: var(--brb);
  color: var(--pcolor) !important;
}
</style>
